import React, { useState, useEffect } from "react";
import { FlexRow, FlexColumn } from "appStyles";
import { Input } from "vComponents";
import { Button } from "components";
import { isCouponValid } from "apis";

function Coupon({ setCouponAmount, setCouponId }) {
  const [code, setCode] = useState("");
  const [message, setMessage] = useState({
    text: "",
    type: null,
  });
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    if (!code)
      return setMessage({
        text: "Coupon code cannot be empty.",
        type: "error",
      });

    try {
      setLoading(true);
      const result = await isCouponValid(code);
      setMessage({
        text: `Applied coupon "${result.name}"!
        The discount will be reflected in your monthly subscription cost even though it is not reflected on this page.`,
        type: "success",
      });
      setCouponId(result.id);
      setCouponAmount(Number(result.amountOff / 100).toFixed(2));
    } catch (e) {
      setCouponId(null);
      setCouponAmount(0);
      setMessage({
        text: e,
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const update = (e) => {
    setMessage({
      text: "",
      type: null,
    });
    setCode(e.currentTarget.value);
  };

  return (
    <FlexColumn height="auto">
      <FlexRow height="auto" margin="20px 0px 0px 0px">
        {loading && (
          <img
            style={{
              width: "35px",
            }}
            src="https://mobile360-assets.s3.us-east-2.amazonaws.com/loading.gif"
          />
        )}
        <Input
          value={code}
          placeholder="ADD COUPON CODE"
          onChange={update}
          style={{
            height: "34px",
          }}
        />
        <Button
          raised
          style={{
            width: "96px",
            fontSize: "13px",
            height: "34px",
          }}
          onClick={onSubmit}
        >
          Apply
        </Button>
      </FlexRow>
      {message.text && (
        <p
          style={{
            color: message.type === "error" ? "#ff6666" : "#89D2D3",
            alignSelf: "flex-start",
          }}
        >
          {message.text}
        </p>
      )}
    </FlexColumn>
  );
}

export default Coupon;
